import { render, staticRenderFns } from "./CreateFieldModal.vue?vue&type=template&id=472df4e4&scoped=true"
import script from "./CreateFieldModal.vue?vue&type=script&lang=js"
export * from "./CreateFieldModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472df4e4",
  null
  
)

export default component.exports